import './styles/style.scss';
import 'regenerator-runtime/runtime.js';
import './language';

const NO_SUPPORT_CODES = [
    'FJ',
    'DZ',
    'KE',
    'SD',
    'IR',
    'GT',
    'NG',
    'PK',
    'GH',
    'LK',
    'MA',
    'BD',
    'IQ',
    'CM',
    'PH',
    'SO',
    'IN',
    'MN',
    'ET',
    'LC',
    'TZ',
    'AF',
    'SV',
    'ML',
    'MR',
    'SZ',
    'CR',
    'MM',
    'KH',
    'EG',
    'TR',
    'NP',
    'BW',
    'NA',
    'SL',
    'SB',
    'BI',
];
const APP_API_URL = 'https://portal3.geozilla.com/api/v1';


const showSupport = code => {
    return NO_SUPPORT_CODES.includes(code);
};

const HELP_SCRIPT = `
(function(w,d){
    w.HelpCrunch=function(){w.HelpCrunch.q.push(arguments)};w.HelpCrunch.q=[];
    function r(){var s=document.createElement('script');s.async=1;s.type='text/javascript';s.src='https://widget.helpcrunch.com/';(d.body||d.head).appendChild(s);}
    if(w.attachEvent){w.attachEvent('onload',r)}else{w.addEventListener('load',r,false)}
})(window, document)

HelpCrunch('init', 'geozilla', {
    applicationId: 1,
    applicationSecret: 'SNbcS5ULRdB8e9ZoV3lzTGpowcSRToWdqwPd8n7YpeXuDXuGirl3XB8Km3YDVMkIMxp4fDAoCJalmbEDJShyGQ=='
})

HelpCrunch('showChatWidget');
`;

const loadScript = scriptBody => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = scriptBody;
    document.body.appendChild(script);
};


(function () {

    const fetchCountry = () => {
        const headers = {'Content-Type': 'application/json'};

        const config = {
            method: 'GET',
            headers: {
                ...headers,
            }
        }

        return window.fetch(`${APP_API_URL}/cf-country`, config).then(async response => {
            const data = await response.json()
            if (response.ok) {
                return data;

            } else {
                return Promise.reject(data)
            }
        })
    };

    fetchCountry().then(
        data => {
            if (data.country_code) {
                if (showSupport(data.country_code)) {
                    return null;
                }

                loadScript(HELP_SCRIPT);
            }
        },
        error => {
            return error;
        }
    );
})
();





